import React, { useEffect, useState } from "react";
import { Container, Typography, Paper, Box } from "@mui/material";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";

const SystemHistoryDashboard = () => {
  const [boardsStart, setBoardsStart] = useState(null);
  const [drawingStart, setDrawingStart] = useState(null);
  const [installationStart, setInstallationStart] = useState(null);

  useEffect(() => {
    fetchSystemHistory();
  }, []);

  const fetchSystemHistory = async () => {
    const snapshot = await getDocs(collection(db, "orders"));
    const orders = snapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(o => o.createdAt)
      .sort((a, b) => a.createdAt.seconds - b.createdAt.seconds);

    // 🧩 عدد اللوحات
    const boardsOrder = orders.find(o => o.boardsCount);
    setBoardsStart(boardsOrder || null);

    // 🎨 الرسم
    const drawingOrder = orders.find(
      o =>
        o.drawingStatus ||
        o.status?.includes("رسم") ||
        o.history?.some(h => h.status?.includes("رسم"))
    );
    setDrawingStart(drawingOrder || null);

    // 🛠️ التركيب
    const installationOrder = orders.find(
      o =>
        o.withAssembly === true ||
        (o.installationFiles && o.installationFiles.length > 0) ||
        o.status?.includes("تركيب")
    );
    setInstallationStart(installationOrder || null);
  };

  const formatDate = (ts) => {
    if (!ts?.toDate) return "—";
    return ts.toDate().toLocaleDateString("ar-EG");
  };

  const InfoBox = ({ title, order }) => (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Typography fontWeight="bold">{title}</Typography>
      {order ? (
        <>
          <Typography>📅 التاريخ: {formatDate(order.createdAt)}</Typography>
          <Typography>👤 الزبون: {order.customerName}</Typography>
        </>
      ) : (
        <Typography color="text.secondary">لا توجد بيانات</Typography>
      )}
    </Paper>
  );

  return (
    <Container sx={{ mt: 4 }} dir="rtl">
      <Typography variant="h4" fontWeight={600} mb={3}>
        📊 سجل تطور النظام
      </Typography>

      <InfoBox
        title="🧩 أول مرة تم إدخال عدد اللوحات"
        order={boardsStart}
      />

      <InfoBox
        title="🎨 أول مرة تم إدخال الرسم"
        order={drawingStart}
      />

      <InfoBox
        title="🛠️ أول مرة تم إدخال التركيب"
        order={installationStart}
      />
    </Container>
  );
};

export default SystemHistoryDashboard;
